
  export default {
    name: "PropertyPolicyBlock",
    props: {
      property: {
        type: Object,
        required: true,
      },
    },
    computed: {
      policy() {
        if (!this.property.booking_policy) {
          return {}
        }

        return this.property.booking_policy;
      }
    }
  };
